<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="40px"
    viewBox="20 -860 830 830"
    width="40px"
  ><path
    class="file-fill"
    d="M448-201.33h66.67V-391l76 76 46.66-47L480-516.67l-156 156L371-314l77-77v189.67ZM226.67-80q-27 0-46.84-19.83Q160-119.67 160-146.67v-666.66q0-27 19.83-46.84Q199.67-880 226.67-880H574l226 226v507.33q0 27-19.83 46.84Q760.33-80 733.33-80H226.67Zm314-542.67v-190.66h-314v666.66h506.66v-476H540.67Zm-314-190.66v190.66-190.66 666.66-666.66Z"
  /></svg>
</template>

<script>
export default {
  name: 'FileUploadIcon',
};
</script>

<style scoped lang="scss">
.file-fill {
  fill: var(--feature-color, main.$npGray);
}
</style>
